var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeterminate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.30823 12 12 9.30847 12 6C12 4.396 11.3762 2.88904 10.2435 1.75647C9.11072 0.623779 7.604 0 6 0C2.69153 0 0 2.69153 0 6C0 7.604 0.623779 9.11096 1.75647 10.2435C2.88904 11.3762 4.396 12 6 12ZM6 11C4.83154 11 3.72498 10.6028 2.83447 9.87256L9.87256 2.83447C10.6028 3.72498 11 4.83154 11 6C11 8.75696 8.75696 11 6 11ZM6 1C7.16821 1 8.27502 1.39722 9.16528 2.12744L2.12744 9.16553C1.39722 8.27502 1 7.16846 1 6C1 3.24304 3.24304 1 6 1Z",
    fill: "#5B6880"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeterminate);
export default __webpack_public_path__ + "static/media/determinate.a41608e40a16f5028efebc0efa172779.svg";
export { ForwardRef as ReactComponent };